import React from 'react';
import PropTypes from 'prop-types';

export default function SkipNavContent({ id, children, ...rest }) {
    return (
        <div
            data-component="SkipNavContent"
            id={id}
            tabIndex="-1"
            style={{ outline: 'none' }}
            {...rest} >
            {children}
        </div>
    );
}

SkipNavContent.propTypes = {
    /** The container id - must match the id in SkipNavLink */
    id: PropTypes.string,

    /** The main body content */
    children: PropTypes.node.isRequired
}

SkipNavContent.defaultProps = {
    id: 'page-content'
}